/**
 * Shared shape primitives for the flat illustrations — the recurring "soft
 * backdrop" card and the circled check badge, so their proportions and
 * palette stay identical across every illustration.
 */
import { colors } from "@/theme/colors";

/** Rounded backdrop rectangle behind an illustration's subject. */
export function Backdrop({
  x,
  y,
  width,
  height,
  fill = colors.tintDeep,
}: {
  x: number;
  y: number;
  width: number;
  height: number;
  fill?: string;
}) {
  return <rect x={x} y={y} width={width} height={height} rx={12} fill={fill} />;
}

/** Filled circle with a white check, proportioned from its radius. */
export function CheckBadge({
  cx,
  cy,
  r,
  fill = colors.success,
}: {
  cx: number;
  cy: number;
  r: number;
  fill?: string;
}) {
  return (
    <g>
      <circle cx={cx} cy={cy} r={r} fill={fill} />
      <path
        d={`M${cx - r * 0.42} ${cy} l${r * 0.3} ${r * 0.3} l${r * 0.55} -${r * 0.6}`}
        fill="none"
        stroke={colors.paper}
        strokeWidth={r * 0.22}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
}
